import { createFileRoute } from '@tanstack/react-router'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'
import { UnsubscribePage } from '#/modules/notifications/front-office/unsubscribe-page/unsubscribe-page.tsx'

export const Route = createFileRoute('/unsubscribe')({
  component: UnsubscribeRoute,
})

function UnsubscribeRoute() {
  return (
    <PharaohNextScope>
      <UnsubscribePage />
    </PharaohNextScope>
  )
}
